import logoVAF from '../../../assets/logo-abogados-vaf.jpeg';
import logoAH from '../../../assets/logo-abogados-ah.png';
import jsPDF from 'jspdf';
import html2pdf from 'html2pdf.js';
import { templateData } from './../case-data';
import { Link, useParams } from 'react-router-dom';
import { getCase, updateCase } from './../../../actions/case-actions';
import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Swal from 'sweetalert2';
import { getDocumentData } from '../../../actions/documents-actions';

function PolicyTemplate(){
    const currentLink = "/casos";
    const dispatch = useDispatch();
    const params = useParams();
    const user = useSelector(state => state.user.user);
    const [needUpdate, setNeedUpdate] = useState(false);
    const [loadData, setLoadData] = useState(true);


    const [currentData, setCurrentData] = useState({});

    const [form, setForm] = useState({
        _id: '',
        policy: {
            generated: false,
            generationDate: new Date()
        },
    })
    
    /*
    // Estos métodos son para formularios dinámicos
    const templateGroup = {
        companyId: '',
        text: ''
    }

    const addGroup = () => {
        form.policy.push(templateGroup);
        setForm({...form})
    }

    const deleteItem = (index) => {
        if (form.policy.length > 1) {
            form.policy.splice(index, 1);
            setForm({...form})   
        }
    }
    // Fin formularios dinámicos

    const handleSearchChange = (event, index) => {
        form.policy[index][event.target.name] = event.target.value;
        setForm({...form})
        if (event.target.value.length > 2) {
            setDropdownValue(event.target.id);
            dispatch( searchQuery( 'company-insurance', event.target.value, searchFunction ) );
        } else {
            setDropdownValue('');
            setDropdown({ show: false, data: [] });
        }
    }

    const searchFunction = ( link, data ) => {
        if(data.code === "01"){
            Swal.fire({
                title:"Error",
                confirmButtonColor:"#76b4ff",
                text: data.message
            });
        }else{
            setDropdown({
                show: true,
                data: data.data
            });
        }
    }

    const setCompanyData = ( data, index ) => {
        form.policy[index].companyId = data._id;
        form.policy[index].text = data.description + ' ' + data.city;
        setForm({...form})
        setDropdownValue('');
        setDropdown({ show: false, data: [] });
    }*/

    useEffect(() => {
        if (loadData) {
            const getFunction = (data) => {
                if(data.code === "01"){
                    Swal.fire({
                        title:"Error",
                        confirmButtonColor:"#76b4ff",
                        text: data.message
                    });
                }else{
                    data.data.legalCompanyText = data.data.legalCompany==='VAF'?'VAF LEGAL S.A.S.':'A&H Abogados - Grupo Jurídico Especializado';
                    data.data.positionText = data.data.legalCompany==='VAF'?'Representante Legal VAF LEGAL S.A.S. NIT. 901638132-1':'Abogado';

                    setCurrentData(data.data);
                    //console.log(data.data);
                    setForm({
                        ...form,
                        _id: data.data._id,
                    })
                    
                }
            }

            setLoadData(false);
            setForm({
                _id: '',
                policy: {
                    generated: false,
                    generationDate: new Date()
                }
            });
            dispatch( getCase( params.id, getFunction, user.token ) );
        }
    }, [loadData, dispatch, params.id, form, currentData, user.token ]);


    const downloadFile = () => {
        if (!currentData.policy.generated) {
            setForm({
                ...form,
                policy: {
                    generated: true,
                    generationDate: new Date()
                }
            })
            setNeedUpdate(true);
        }

        let doc = new jsPDF('p', 'pt', 'a4');
        const element = document.querySelector("#capture");
        const marginX = 20;
        const opt = {
            margin: [38, marginX, 23, marginX],
            filename: `5 POLIZA ${currentData.client.clientId.lastName.toUpperCase()} EXP ${currentData.filingNumber}.pdf`,
            enableLinks: false,
            pagebreak: {
              avoid: ['tr'],
              mode: ['css', 'avoid-all'],
            },
            image: { type: 'jpeg', quality: 0.7 },
            html2canvas: {
              allowTaint: true,
              dpi: 300,
              letterRendering: true,
              logging: false,
              scale: 2,
              scrollX: 0,
              scrollY: 0,
            },
            jsPDF: { doc },
          };

        html2pdf()
        .from(element)
        .set(opt)
        .toPdf()
        .get('pdf')
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .then((pdf) => {
            const totalPages = pdf.internal.getNumberOfPages();
            for (let i = 1; i < totalPages + 1; i++) {
                pdf.setPage(i);
                pdf.setFontSize(7);

                let heightSpace = pdf.internal.pageSize.getHeight() - 12;
                let logo = currentData.legalCompany === 'VAF'? logoVAF:logoAH;
                const sizeX = currentData.legalCompany === 'VAF'? 38:33;
                const sizeY = currentData.legalCompany === 'VAF'? 20:23;
                let posX = pdf.internal.pageSize.getWidth()-(marginX+sizeX);
                // Validación de espacio porque el logo tiene márgenes
                posX = currentData.legalCompany === 'VAF'?(posX+4):posX;
                const posY = 10;

                // addImage(img, posX, posY, sizeX, sizeY) => posX = marginX+sizeX
                pdf.addImage(logo, posX, posY, sizeX, sizeY);

                Object.keys(templateData.company).map((keyName, i) => {
                    pdf.text(
                        `${templateData.company[keyName]}`,
                        (pdf.internal.pageSize.getWidth()/2)-(templateData.company[keyName].length/2),
                        heightSpace,
                    );
                    heightSpace += 3;
                    return i;
                })
                const pages = `${i}/${totalPages}`;
                pdf.text(
                    pages,
                    (pdf.internal.pageSize.getWidth()/2)-(pages.length/2),
                    heightSpace,
                );
            }
        })
        .save();
    }

    useEffect(() => {
        const updateFunction = (data) => {
            if(data.code === "01"){
                Swal.fire({
                    title:"Error",
                    confirmButtonColor:"#76b4ff",
                    text: data.message
                });
            }else{
                //navigate(currentLink)
                //console.log(data);
                /*
                Swal.fire({
                    title:"¡Éxito!",
                    confirmButtonColor:"#76b4ff",
                    text: "Caso creado con éxito"
                });*/
            }
        }

        if (needUpdate) {
            dispatch( updateCase( form, updateFunction, user.token) );
            setNeedUpdate(false);
            setLoadData(true);
        }
        //console.log(form)
    }, [needUpdate, dispatch, form, user.token]);

    return (
        <div className="w-100 d-flex">
            <div className="container d-flex flex-column">
                <div className="w-100 mt-5">
                    <Link to={currentLink + `/editar/${params.id}`} key={params.id} className="back-button">&#60; Volver</Link>
                </div>
                <h1 className="my-5">Solicitud afectación poliza</h1>
                <div className="d-flex flex-column w-100">
                    <div className="d-flex flex-column p-4 template-container document-container">
                        <img src={currentData.legalCompany === 'VAF'? logoVAF:logoAH} alt="Logo" className="lawer-logo" />
                        { currentData._id ? 
                            getDocumentData('policy', currentData)
                        :''}
                        <div id="footer" className="d-flex justify-content-center w-100 info-span-container">
                            <div className="d-flex flex-column">
                                {Object.keys(templateData.company).map((keyName, i) => (
                                    <span key={i} className="info-span">{templateData.company[keyName]}</span>
                                ))}
                            </div>
                        </div>
                    </div>
                    <div className="d-flex justify-content-center w-100 my-2">
                        <button onClick={downloadFile} className="primary-button save-button">Descargar</button>
                    </div>
                </div>
            </div>
        </div>
    );
}
 
export default PolicyTemplate;